import { render, staticRenderFns } from "./AnonymisationFieldOverview.vue?vue&type=template&id=5bd60621&"
import script from "./AnonymisationFieldOverview.vue?vue&type=script&lang=ts&"
export * from "./AnonymisationFieldOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports